import React, { useState, useEffect } from 'react';
import { getDevice, getDeviceDataByID } from '../../services/deviceService';
import { useLocation } from 'react-router-dom';
import HighChartJs from '../../components/chart/highchart';
import dayjs from 'dayjs';
import { Spin } from 'antd';
import { DatePicker } from "antd";
import { showError } from '../../services/toastService';

function GraphicalUI({ userData }) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('device');

    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [graphBVData, setGraphBVData] = useState();
    const [graphSections, setGraphSections] = useState();
    const [macAddress, setMacAddress] = useState('');
    const [deviceName, setDeviceName] = useState('');

    const goToPreviousDay = () => {
        setCurrentDate((prevDate) => prevDate.subtract(1, 'day'));
        //getDeviceData(deviceId);
    };

    const goToNextDay = () => {
        const nextDate = currentDate.add(1, 'day');
        const today = dayjs(); // Get today's date

        // Check if the next date is in the future
        if (nextDate.isAfter(today)) {
            return; // Prevent future dates
        }

        setCurrentDate(nextDate);
        // getDeviceData(deviceId); // Fetch data for the next day
    };

    const getDeviceData = async (id) => {
        if (!id) {
            setError('Device ID not provided');
            return;
        }
        try {
            setLoading(true);
            setGraphBVData(null);
            const response = await getDeviceDataByID(id, currentDate.format('YYYY-MM-DD'));
            if (Array.isArray(response?.graph)) {
                setGraphBVData(response.graph);
            } else {
                setGraphBVData();
            }

            setMacAddress(response?.device?.mac);
            setDeviceName(response?.device?.name);
            //console.log(response?.device)
            setGraphSections(response?.device?.columns)
        } catch (error) {
            console.error('Error fetching device data:', error);
            // setError('Failed to fetch device data');
            showError('Failed to fetch device data')
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (deviceId) {
            getDeviceData(deviceId); // Re-fetch device data when deviceId is available
        }
    }, [currentDate, deviceId]); // Fetch data whenever currentDate or deviceId changes

    const onChange = (date, dateString) => {
        setCurrentDate(date)
    };

    const disabledDate = (current) => {
        // Disable dates after today
        return current && current.isAfter(dayjs(), 'day');
    };

    return (
        <div className='content-wrappers'>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{deviceName ? deviceName : 'Device Name'} : <small>{macAddress ? macAddress : 'MAC Address'}</small></h3>
                        </div>
                        <div className="card-body">
                            <div className='col-12 text-center'>
                                <div className="row">
                                    <div className='col-3'>
                                        <i className="fa fa-arrow-left float-right" onClick={goToPreviousDay} style={{ fontSize: 25, cursor: 'pointer' }}></i>
                                    </div>
                                    <div className='col-6'>
                                        <div style={{ margin: '0 20px' }}>
                                            <DatePicker value={currentDate} onChange={onChange} readOnly format={'DD-MM-YYYY'} disabledDate={disabledDate} />
                                            {/* <input type='text' value={currentDate.format('DD-MM-YYYY')} readOnly style={{ textAlign: 'center' }} /> */}
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <i className="fa fa-arrow-right float-left" onClick={goToNextDay} style={{ fontSize: 25, cursor: 'pointer' }}></i>
                                    </div>
                                </div>
                            </div>

                            {loading ?
                                (
                                    <div className="loading-container mt-20">
                                        <Spin fullscreen={false} size={'large'}>
                                            <div className="spinner"></div>
                                        </Spin>

                                    </div>
                                )
                                : <>
                                    {graphBVData && graphBVData.length ? (
                                        <>

                                            {graphSections.map(field => (
                                                <HighChartJs
                                                    key={field.name}
                                                    data={graphBVData}
                                                    title={field.description}
                                                    valueField={field.name}
                                                    chartdiv={`chart_${field.name}`}
                                                />
                                            ))}

                                            {/* <HighChartJs data={graphBVData} title="Ice Temperature" valueField="icetemp" chartdiv={`chart2`} />
                                    <HighChartJs data={graphBVData} title="P V Temp" valueField="pvtemp" chartdiv={`chart5`} />
                                    <HighChartJs data={graphBVData} title="Compressor Speed" valueField="comp" chartdiv={`chart3`} />
                                    <HighChartJs data={graphBVData} title="DCVT" valueField="dcvt" chartdiv={`chart4`} />
                                    <HighChartJs data={graphBVData} title="Battery Voltage" valueField="batteryvolt" chartdiv={`chart1`} /> */}
                                        </>
                                    ) : <div className='text-center mt-5'>
                                        There are no records to display
                                    </div>}
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GraphicalUI;
